import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

export const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: {
      title: "Settings",
      icon: "mdi-cog",
      nav: true,
    },
  },
  {
    path: "/groups",
    name: "groups",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Groups.vue"),
    meta: {
      title: "Groups",
      icon: "mdi-account-box",
      nav: true,
    },
  },
  {
    path: "/groups/:id",
    name: "group",
    component: () => import("../views/Group.vue"),
    meta: {
      title: "Group",
      nav: false,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
